export enum DATA_QA {
  ROOT = 'campaign-basic-info',
  CALL_CENTER = 'campaign-basic-info__call-center',
  CALL_CENTER_VALUE = 'campaign-basic-info__call-center-value',
  CALLER_ID = 'campaign-basic-info__caller-id',
  CALLER_ID_VALUE = 'campaign-basic-info__caller-id-value',
  LIST = 'campaign-basic-info__list',
  LIST_VALUE = 'campaign-basic-info__list-value',
}
